import React from 'react'
import { useState } from 'react';

const ChevronIcon = (active)=> {
    let pathD = 'M6 9L12 15L18 9';
    
    if(active) pathD = 'M6 15L12 9L18 15';

    return(
        <svg 
            width="28px" 
            height="28px"
            fill="none"
            viewBox='0 0 28 28' 
            xmlns="http://www.w3.org/2000/svg"
        >
            <g strokeWidth="0" />
            <g strokeLinecap="round" strokeLinejoin="round" />
            <g> 
                <path d={pathD} stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </g>
        </svg>
    )
}

export default function ServiceCardDetailCilindro({selectorValue, isCustomSelector = false, handleCustomSelector = ()=>{}}) {
    const [isChevronActive,setIsChevronActive] = useState(false);

    const onCustomClick= ()=> {
        if(!isCustomSelector) return;
        setIsChevronActive(!isChevronActive);
        handleCustomSelector();
    }

    return (
        <div 
            style={{
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems:'center', 
                cursor: isCustomSelector ? 'pointer' : 'auto' 
            }}
            onClick={onCustomClick}
        >
            <div 
                style={{ 
                    width: isMobileDevice()? 'calc(100% - 24px)': '40%', 
                    textAlign: 'start',
                }}
            >
                <div className="servicios-servicio-box-details-address">
                    <p>{selectorValue.client_address}</p>
                </div>

                <div className="servicios-servicio-box-details-city">
                    <p>{selectorValue.client_city + ", " + selectorValue.client_region_cod}</p>                    
                </div>
            </div>

            {isCustomSelector &&
                    ChevronIcon(isChevronActive)
            }
        </div>
    )
}

function isMobileDevice() {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
      return false;
    }
}